import React from 'react'

import * as RadixCollapsible from '@radix-ui/react-collapsible'
import {
  arrowTrigger,
  arrowTriggerClosedLabel,
  arrowTriggerIcon,
  arrowTriggerOpenLabel,
  collapsibleContent,
  collapsibleTrigger,
} from './Collapsible.css'
import { Icon } from 'public/assets/v2/images/icons'
import clsx from 'clsx'

export const Collapsible = ({ children, ...rest }) => {
  return <RadixCollapsible.Root {...rest}>{children}</RadixCollapsible.Root>
}

const CollapsibleTrigger = ({
  children,
  ...rest
}: React.ComponentProps<typeof RadixCollapsible.Trigger>) => {
  return (
    <RadixCollapsible.Trigger {...rest}>{children}</RadixCollapsible.Trigger>
  )
}

const CollapsibleArrowTrigger = ({
  openLabel = 'Show More',
  closedLabel = 'Show Less',
}) => {
  return (
    <CollapsibleTrigger className={`${collapsibleTrigger} ${arrowTrigger}`}>
      <span className={arrowTriggerOpenLabel}>{openLabel}</span>
      <span className={arrowTriggerClosedLabel}>{closedLabel}</span>
      <Icon.ArrowDownIcon className={arrowTriggerIcon} />
    </CollapsibleTrigger>
  )
}

const CollapsibleContent = ({
  children,
  className,
  ...rest
}: React.ComponentProps<typeof RadixCollapsible.Content>) => {
  return (
    <RadixCollapsible.Content
      className={clsx(collapsibleContent, className)}
      {...rest}
    >
      {children}
    </RadixCollapsible.Content>
  )
}

Collapsible.Trigger = CollapsibleTrigger
Collapsible.ArrowTrigger = CollapsibleArrowTrigger
Collapsible.Content = CollapsibleContent
